// src/api/processApi.js
// 加工订单模块（独立于现有门店订单，仅工厂店可用）
// 对应后端 ProcessOrderController / ProcessStoreController / ProcessPurchaseController
import { reqF } from "./axiosFun";
import { reqBlob } from "./exportFile";

/* ==================== 加工订单 ==================== */

// 分页获取加工订单
export const GetProcessOrderPageList = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/GetProcessOrderPageList", params);
};
// 获取加工订单详情（含明细、可用库存、在途采购量）
export const GetProcessOrderInfo = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/GetProcessOrderInfo", params);
};
// 生成加工订单编号
export const GenerateProcessOrderNumber = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/GenerateOrderNumber", params);
};
// 创建加工订单
export const CreateProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/CreateProcessOrder", params);
};
// 编辑加工订单（仅待确认/已退回可改）
export const EditProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/EditProcessOrder", params);
};
// 删除加工订单（仅待确认可删）
export const DeleteProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/DeleteProcessOrder", params);
};
// 确认加工订单（丹阳加工确认即完成；门店加工转待加工）
export const ConfirmProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/ConfirmProcessOrder", params);
};
// 退回加工订单
export const ReturnProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/ReturnProcessOrder", params);
};
// 撤单（终态）
export const CancelProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/CancelProcessOrder", params);
};
// 人工完成（加工中 → 已完成）
export const FinishedProcessOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/FinishedProcessOrder", params);
};
// 订单操作记录
export const GetProcessOrderHistory = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/GetProcessOrderHistory", params);
};
// 加工订单统计
export const GetProcessOrderStatistic = (params) => {
	return reqF("post", "/api/sysConfig/ProcessOrder/GetProcessOrderStatistic", params);
};

/* ==================== 出库 / 入库 / 工厂店库存 ==================== */

// 出库预览（只读）：逐条返回需求量 / 可用库存 / 是否缺口 / 在途采购量
export const PreviewProcessOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/PreviewOutputStore", params);
};
// 出库方式一：库存出库
export const CreateProcessOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/CreateOutputStore", params);
};
// 出库方式三：更换商品出库
export const EditGoodsProcessOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/EditGoodsOutputStore", params);
};
// 出库单作废（回补库存，订单回到待加工）
export const CancelProcessOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/CancelOutputStore", params);
};
// 出库单列表
export const GetProcessOutputStorePageList = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/GetOutputStorePageList", params);
};
// 出库单详情
export const GetProcessOutputStoreInfo = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/GetOutputStoreInfo", params);
};
// 入库单列表
export const GetProcessInputStorePageList = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/GetInputStorePageList", params);
};
// 入库单详情
export const GetProcessInputStoreInfo = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/GetInputStoreInfo", params);
};
// 工厂店库存列表
export const GetProcessWareHousePageList = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/GetWareHousePageList", params);
};
// 手工调整工厂店库存
export const UpdateProcessWareHouseQty = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/UpdateWareHouseQty", params);
};
// 库存流水列表
export const GetProcessWareHouseHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/ProcessStore/GetWareHouseHistoryPageList", params);
};

/* ==================== 加工采购单 ==================== */

// 出库方式二：创建采购单出库（不建出库单，订单转采购中）
export const CreatePurchaseProcessOutputStore = (params) => {
	return reqF("post", "/api/sysConfig/ProcessPurchase/CreatePurchaseOutputStore", params);
};
// 加工采购单分页列表
export const GetProcessPurchasePageList = (params) => {
	return reqF("post", "/api/sysConfig/ProcessPurchase/GetProcessPurchasePageList", params);
};
// 导出加工采购单
export const ExportProcessPurchaseOrder = (params) => {
	return reqBlob("post", "/api/sysConfig/ProcessPurchase/ExportProcessPurchaseOrder", params);
};
// 批量修改供应商
export const EditProcessPurchaseSupply = (params) => {
	return reqF("post", "/api/sysConfig/ProcessPurchase/EditProcessPurchaseSupply", params);
};
// 采购单入库
export const InputStoreByProcessPurchase = (params) => {
	return reqF("post", "/api/sysConfig/ProcessPurchase/InputStoreByPurchase", params);
};
// 删除采购单
export const DeleteProcessPurchaseOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessPurchase/DeleteProcessPurchaseOrder", params);
};
// 取消采购单
export const CancelProcessPurchaseOrder = (params) => {
	return reqF("post", "/api/sysConfig/ProcessPurchase/CancelProcessPurchaseOrder", params);
};
